(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2246],{

/***/ 13742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Check; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91373);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]];
const Check = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("check", __iconNode);


//# sourceMappingURL=check.js.map


/***/ }),

/***/ 7314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Minus; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91373);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { d: "M5 12h14", key: "1ays0h" }]];
const Minus = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("minus", __iconNode);


//# sourceMappingURL=minus.js.map


/***/ }),

/***/ 31012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Plus; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91373);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
];
const Plus = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("plus", __iconNode);


//# sourceMappingURL=plus.js.map


/***/ }),

/***/ 14191:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clm/esignatures",
      function () {
        return __webpack_require__(73773);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _v3_Buttons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56475);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);



const CLMHero2 = (param)=>{
    let { CLMHeroData  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: "max-w-screen-xl mx-auto text-black relative mb-5 md:mb-24 md:mt-16 md:mt-0",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative z-10 flex flex-col items-center justify-start md:gap-6 px-4 md:px-0",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col items-center justify-center gap-6 md:gap-7 mt-8 w-full ",
                        children: [
                            CLMHeroData.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-2xl text-violet-600 uppercase",
                                children: CLMHeroData.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "text-5xl leading-[48px] md:text-[72px] md:leading-[72px] text-center max-w-full md:w-[95%] xl:w-[90%] font-semibold",
                                children: CLMHeroData.heading
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-lg font-medium text-gray-800 md:text-2xl text-center md:w-[80%]",
                                children: CLMHeroData.description
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_v3_Buttons__WEBPACK_IMPORTED_MODULE_1__/* .CLMButtonPrimary */ .IS, {
                                buttonText: CLMHeroData.btnText,
                                buttonUrl: CLMHeroData.btnUrl
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "max-w-screen-xl md:mx-8 mx-auto pt-8",
                        children: [
                            CLMHeroData.video && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                                src: CLMHeroData.video,
                                alt: "ai-agent-builder",
                                width: 1216,
                                height: 500,
                                className: "rounded-xl",
                                autoPlay: true,
                                loop: true,
                                muted: true
                            }),
                            CLMHeroData.image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                src: CLMHeroData.image,
                                alt: "ai-agent-builder",
                                width: 1216,
                                height: 500,
                                className: "rounded-xl"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CLMHero2);


/***/ }),

/***/ 8129:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _v3_Buttons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56475);


const CTASection = (param)=>{
    let { btnText , btnUrl  } = param;
    return /*#__PURE__*/ _jsxs("section", {
        className: "bg-[#f4f2f0] text-black py-16 md:px-10 px-4 xl:px-20 text-center",
        children: [
            /*#__PURE__*/ _jsx("h1", {
                className: "text-4xl md:text-7xl font-semibold leading-snug md:mt-20 mt-4 max-w-screen-xl mx-auto mb-16 tracking-tight",
                children: "Transform service with BoloSign's AI agent platform"
            }),
            /*#__PURE__*/ _jsx(CLMButtonPrimary, {
                buttonText: btnText,
                buttonUrl: btnUrl
            })
        ]
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (CTASection)));


/***/ }),

/***/ 24062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13742);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);





const EqualDivisionSection = (param)=>{
    let { title , heading , description , checks , image ="" , video ="" , bgColor , imageRight =true , opinion , imageRounded =true , leftDivStyle =""  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat(bgColor, " py-7 md:py-32 transition-all duration-700"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-screen-xl md:px-8 px-6 mx-auto grid md:grid-cols-2 gap-6 md:gap-12 xl:gap-20 items-start ".concat(leftDivStyle),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "".concat(imageRight ? "md:order-1" : "md:order-2", " order-1"),
                    children: [
                        title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "uppercase text-purple-900 mb-2 text-xs md:text-base font-semibold",
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "".concat(bgColor == "bg-dark" ? "text-white" : "", " text-[28px]  md:text-4xl xl:text-5xl font-semibold text-start ").concat(heading && "mb-6"),
                            children: heading
                        }),
                        description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "".concat(bgColor == "bg-dark" ? "text-white" : "text-gray-900", " mb-6  md:text-2xl font-semibold md:font-normal font-medium text-left"),
                            children: description
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: "space-y-4 ".concat(bgColor == "bg-dark" ? "text-white" : "text-gray-800", " text-lg md:leading-none xl:leading-relaxed"),
                            children: checks.map((check, idx)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                    className: "flex items-start text-start",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            className: "w-5 h-5 text-gray-800 bg-purple-200 rounded-full p-1 mr-2 mt-1 shrink-0"
                                        }),
                                        check
                                    ]
                                }, idx))
                        }),
                        opinion && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "".concat(bgColor == "bg-dark" ? "text-white" : "text-black", " mb-6  md:text-base w-[70%] pl-4 font-semibold font-medium mt-10 text-start hidden md:block"),
                            children: [
                                opinion,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: "-BoloSign User"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "bg-color  rounded-2xl relative  ".concat(imageRight ? "order-2" : "order-1"),
                    children: [
                        image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: image,
                            alt: "Contract Creation",
                            width: 500,
                            height: 500,
                            className: "w-full ".concat(imageRounded ? "rounded-2xl" : "")
                        }),
                        video && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                            src: video,
                            autoPlay: true,
                            muted: true,
                            loop: true,
                            className: "w-full h-full object-cover rounded-2xl"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EqualDivisionSection);


/***/ }),

/***/ 74791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7314);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31012);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



function FaqItem(param) {
    let { question , answer , isOpen , onToggle  } = param;
    const contentRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [height, setHeight] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isOpen && contentRef.current) {
            setHeight(contentRef.current.scrollHeight);
        } else {
            setHeight(0);
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        onClick: onToggle,
        className: "px-8 py-7 transition-all duration-300",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                className: "flex justify-between items-center w-full text-left gap-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "text-[20px] leading-[26px] font-semibold",
                        children: question
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-purple-600 text-xl border-2 border-purple-600 rounded-full p-1",
                        children: isOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            size: 20
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            size: 20
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: contentRef,
                style: {
                    maxHeight: "".concat(height, "px"),
                    overflow: "hidden",
                    transition: "max-height 0.3s ease, opacity 0.3s ease",
                    opacity: isOpen ? 1 : 0
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: answer
                    },
                    className: "mt-6 text-gray-700 text-[18px] leading-[26px] font-medium"
                })
            })
        ]
    });
}
function FaqList(param) {
    let { faqs  } = param;
    const [openIndex, setOpenIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: faqs.map((faq, index)=>{
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: " bg-white rounded-2xl border border-surface-dark mt-4 text-left w-full mx-auto ".concat(openIndex === index ? "" : "hover:bg-surface-dark", " transition-all  duration-300"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqItem, {
                    question: faq === null || faq === void 0 ? void 0 : faq.question,
                    answer: faq === null || faq === void 0 ? void 0 : faq.answer,
                    isOpen: openIndex === index,
                    onToggle: ()=>setOpenIndex(openIndex === index ? null : index)
                }, index)
            }, index);
        })
    });
}
const FAQ2 = (param)=>{
    let { faqData , heading , description  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "md:w-[920px] max-w-full mx-auto",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "text-4xl md:text-5xl font-semibold leading-snug mb-8",
                children: heading
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-[18px] leading-[22px] font-medium md:w-[80%] mx-auto w-full mt-2 mb-12",
                children: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqList, {
                faqs: faqData
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FAQ2);


/***/ }),

/***/ 73773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_CLM_CLMHero2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29937);
/* harmony import */ var components_CLM_CTASection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8129);
/* harmony import */ var components_CLM_EqualDivisionSection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24062);
/* harmony import */ var components_CLM_FAQ2__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74791);
/* harmony import */ var components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56475);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43138);








const CLMHeroData = {
    // title: "Reporting",
    heading: "Legally-binding eSignatures within BoloSign CLM",
    description: "Secure digital signatures, legally binding and built for contracts—only with BoloSign.",
    image: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/v2/clm/clm/hero-esignature.png"),
    btnText: "Request a Demo",
    btnUrl: "/clm/request-demo"
};
const eSignatureFaqData = [
    {
        question: "What is BoloSign eSignature?",
        answer: "BoloSign eSignature is a secure digital signing solution built into the BoloSign platform, allowing users to obtain legally binding electronic signatures without relying on paper or third-party tools. It supports industry-standard cryptographic methods to ensure every signature is authentic and verifiable. With BoloSign eSignature, you can streamline your document approvals in a single, centralized interface."
    },
    {
        question: "How does BoloSign simplify the document signing workflow?",
        answer: "By replacing manual printing and mailing with an end-to-end digital process, BoloSign lets you upload documents, assign signers, and track progress in real time—all from your dashboard. Signatories receive an email link to review and sign on any device, and you can monitor exactly when each party has signed. This unified, browser-based experience eliminates bottlenecks and keeps everyone on the same page."
    },
    {
        question: "How does BoloSign protect my documents and signatures?",
        answer: "Every transaction in BoloSign is secured using industry-grade encryption, ensuring documents remain confidential both in transit and at rest. Detailed audit logs record each action—who opened, viewed, or signed a file and when—so you have a transparent trail for compliance or disputes. You can also add optional one-time passwords (OTPs) to signature links for an extra layer of identity verification."
    },
    {
        question: "Is BoloSign eSignature legally recognized worldwide?",
        answer: "Yes. BoloSign eSignature meets major global electronic signature regulations—such as ESIGN (U.S.), eIDAS (EU), and additional standards like UETA, ensuring signatures obtained through our system are enforceable in most jurisdictions. By adhering to these frameworks, BoloSign guarantees that your electronically signed agreements carry the same legal weight as traditional wet-ink signatures."
    },
    {
        question: "Can I send signature requests from any device using BoloSign?",
        answer: "Absolutely. Whether your signers are on a desktop, laptop, tablet, or smartphone, they can open the link, review the document, and apply their electronic signature without installing any software. This device-agnostic approach ensures no one is blocked by operating system or hardware limitations—signing is as simple as clicking a link."
    },
    {
        question: "Does BoloSign send notifications and reminders about pending signatures?",
        answer: "Yes. As soon as you send a signature request, BoloSign delivers an email notification to each signer with a direct link to the document. If a signer hasn’t acted within your specified timeframe, automated reminders are dispatched to keep the process moving. You’ll also receive real-time status updates whenever someone completes or declines a signature."
    },
    {
        question: "Can I set an expiration date for a signature link in BoloSign?",
        answer: "You can. When preparing a document for signature, simply choose an expiration date for each signing link to ensure that agreements are executed within a defined window. Once the link expires, signers can no longer access the document, helping you maintain control over timing and enforce deadlines."
    },
    {
        question: "Can I customize the signing order for multiple signers?",
        answer: "Yes. BoloSign allows you to define a sequential signing order when multiple parties are involved. You can specify exactly who signs first, second, and so on—ensuring critical stakeholders review and approve documents in the right sequence. Alternatively, you can enable parallel signing if order doesn't matter, allowing all signers to act simultaneously. This flexibility keeps your workflow aligned with your business needs."
    }
];
const Esignatures = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "eSignatures - BoloSign CLM"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Secure, legally binding eSignatures built for contracts—only with BoloSign CLM."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "BoloSign eSignature, digital signatures, electronic signatures, contract signing, secure eSignatures, legally binding signatures, contract lifecycle management, CLM eSignatures"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/clm/esignatures/"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_CLMHero2__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                CLMHeroData: CLMHeroData
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-center bg-cream pt-20 md:pt-32 ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "text-4xl md:text-5xl xl:text-6xl px-6 md:px-0 md:-mb-10 text-start md:text-center",
                        children: "Close contracts faster with BoloSign CLM"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_EqualDivisionSection__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        heading: "Faster contract execution with digital signatures",
                        description: "BoloSign’s native eSign lets you collect legally binding signatures instantly and securely.",
                        checks: [
                            "Skip paper or extra tools; sign anywhere, on any device.",
                            "Monitor progress live and auto-save contracts in your BoloSign repository."
                        ],
                        image: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/v2/clm/clm/signature-coat.png"),
                        bgColor: "bg-cream",
                        imageRight: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_EqualDivisionSection__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        // title=""
                        heading: "Secure and globally compliant eSignatures",
                        description: "Protect every signature with enterprise-grade security and international compliance.",
                        checks: [
                            "Control access – Set expiry dates on contract links.",
                            "Verify identity – Use OTPs and unique signer IDs.",
                            "Track everything – Get detailed logs of every action."
                        ],
                        image: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/v2/clm/clm/signature-financial-review.png"),
                        bgColor: "bg-white",
                        imageRight: false
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_EqualDivisionSection__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        // title=""
                        heading: "Contract management and eSigning in one platform",
                        description: "Manage the full contract lifecycle—from draft to signature—right inside BoloSign.",
                        checks: [
                            "Full context at signing – View revision history and key details.",
                            "Custom workflows – Set up signing and approvals your way.",
                            "Track at scale – Monitor eSign status with smart reports."
                        ],
                        image: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/v2/clm/clm/signature-add-signature.png"),
                        bgColor: "bg-cream",
                        imageRight: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_EqualDivisionSection__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        // title=""
                        heading: "Collect signatures effortlessly, anywhere",
                        description: "Speed up signing with flexible options and real-time notifications.",
                        checks: [
                            "Sign on any device – Laptop, phone, or tablet.",
                            "Stay updated – Get alerts via BoloSign Dashboard or email.",
                            "Flexible formats – Sign via link or directly on DOC, DOCX, or PDF."
                        ],
                        image: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/v2/clm/clm/signature-new-contract.png"),
                        bgColor: "bg-white",
                        imageRight: false
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "bg-[#f4f2f0] text-black py-16 md:px-10 px-4 xl:px-20 text-center md:pt-24 pt-12 ",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_FAQ2__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    faqData: eSignatureFaqData,
                    heading: "FAQs"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Esignatures);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(14191); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);